import { render } from "./PromotionBannerComponent.vue?vue&type=template&id=01f462b8"
import script from "./PromotionBannerComponent.vue?vue&type=script&lang=js"
export * from "./PromotionBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__